<template>
  <div>
    <div v-if="!skipMapAuth.val && !user">
      <v-list-item link href="/auth/provider">
        <v-list-item-icon><v-icon>mdi-login</v-icon></v-list-item-icon>
        <v-list-item-content><v-list-item-title>Sign In</v-list-item-title></v-list-item-content>
      </v-list-item>
    </div>
    <!-- Only show this block if map auth is disabled AND there is no active user session -->
    <div v-if="skipMapAuth.val && !user" >
      <v-list-item to="/home">
          <v-list-item-icon><v-icon>mdi-home</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Home</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-subheader>Navigate</v-subheader>
      <v-list-item to="/directions?b=32">
          <v-list-item-icon><v-icon>mdi-directions</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Directions</v-list-item-title></v-list-item-content>
      </v-list-item>
      
      <v-subheader>Maps</v-subheader>
      <div v-for="(building, i) in buildings" :key="i">
          <v-list-item link :to="'/maps/'+building">
            <v-list-item-icon>
              <v-icon>mdi-map-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Building {{building}}</v-list-item-title>
          </v-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import AnalyticsTracker from '../../services/MitAnalyticsTracker.js';
import BaseMitConfigService from '../../../base/services/BaseMitConfigService.js';
import BaseMitUserService from '../../../base/services/BaseMitUserService.js';
import MitSpacesService from '../../services/MitSpacesService.js';

export default {
  name: 'MitMenu',
  hasPublicItems: true, 
  props: {
    userModel: Object
  },
  data() {
    return {
      skipMapAuth: {
        val:false
      },
      user:null,
      buildings: []
    }
  },
  async created() {
    // Await the session initialization to ensure the backend creates the session
    await AnalyticsTracker.initSession();
    // Fetch the client config to check the toggle
    // const config = BaseMitConfigService.get("CLIENT_REQUIRE_MAP_AUTH", true);
    // if (config) {
    //     this.requireMapAuth = config.REQUIRE_MAP_AUTH === "true";
    // }
    // Force it to a boolean if it's coming back as a string
    this.skipMapAuth.val = BaseMitConfigService.get("SKIP_MAP_AUTH");
    this.user = BaseMitUserService.getUser()
        .then((user) => {
            this.user = user;
        });


    // Only fetch the building list if the feature is open to the public
    if (this.skipMapAuth.val) {
      MitSpacesService.getBuildingsMitIdUniqueList()
      .then((buildings) => {
          this.buildings = buildings;
      })
      .catch((error) => console.error(error));
    }
  }
}
</script>